import {sanitizeAnalyticsParam, sanitizeAnalyticsParams} from './sanitize';
import {consoleApi} from './api/console';
import {gtagApi} from './api/gtag';
import type {AnalyticsApi} from './api/type';

export type {AnalyticsApi};

export {gtagApi, consoleApi, sanitizeAnalyticsParam, sanitizeAnalyticsParams};

export type TrackingEvent = {
    name: string;
    [key: string]: unknown;
};

declare global {
    interface Window {
        dataLayer: Array<any>;
    }
}

let api: AnalyticsApi = gtagApi;

let handleInitFinished: () => void;
const waitInitialization = new Promise<void>((resolve) => {
    handleInitFinished = resolve;
});

export const initAnalytics = (trackingId: string, options?: {api?: AnalyticsApi}): Promise<void> => {
    if (options?.api) {
        api = options.api;
    }
    return api.initialize(trackingId).then(handleInitFinished);
};

let currentScreenName: string = '';

export const resetScreenName = (): void => {
    currentScreenName = '';
};

export const setScreenName = (screenName: string, params?: {[key: string]: unknown}): Promise<void> => {
    return waitInitialization.then(() => {
        const sanitizedScreenName = sanitizeAnalyticsParam(screenName);

        if (sanitizedScreenName === currentScreenName) {
            return;
        }

        currentScreenName = sanitizedScreenName;

        return api.setScreenName(sanitizedScreenName, sanitizeAnalyticsParams(params || {}));
    });
};

export const logEvent = (event: TrackingEvent): Promise<void> => {
    return waitInitialization.then(() => {
        const {name, ...rest} = sanitizeAnalyticsParams(event);

        return api.logEvent(name as string, {
            ...rest,
            screenName: rest.screenName || currentScreenName,
        });
    });
};

export const setUserProperty = (name: string, value: string): Promise<void> => {
    return waitInitialization.then(() => api.setUserProperty(name, sanitizeAnalyticsParam(value)));
};
